import { gql } from '@apollo/client';
const TENANT_SUPPLIER = gql `
  fragment TenantSupplierFragment on SupplierNode {
    id
    code
    status
    canBeRemoved
    canFullNameBeUpdated
    shortName
    fullName
    vatNumber
    countryOfOrigin
    addressPostalCode
    addressCity
    addressStreet
    addressNumber
    emailAddress
    contactPhone
  }
`;
export default TENANT_SUPPLIER;
